import { useMemo } from "react";

import { useGetUserFoldersQuery } from "@/graphql/folders/folders.hooks";

interface IUseGetUserFolders {
  skip?: boolean;
}

function useGetUserFolders({ skip }: IUseGetUserFolders = {}) {
  const { data, loading, error, refetch } = useGetUserFoldersQuery({
    context: { errorType: "local" },
    fetchPolicy: "cache-first",
    skip,
  });

  return useMemo(
    () => ({
      data: data?.user.folders ?? [],
      loading,
      error,
      refetch,
    }),
    [data, loading, error, refetch]
  );
}

export default useGetUserFolders;
